module.exports = __webpack_public_path__ + "static/media/brand_logo.d5971366.svg";